import BaseSyncError from "scripts/exceptions/baseSyncError";

class NotFoundSyncError extends BaseSyncError {}

export default NotFoundSyncError;
